import { doc, getDoc, type Firestore } from 'firebase/firestore';
import {
  NOTIFICATION_RECIPIENTS_COLLECTION,
  type NotificationRecipientsDoc,
} from '@kawai/shared';
import { db as defaultDb } from '../firebase.js';

/**
 * N-15b: `notification_recipients/{tenantId}`（テナントに 1 doc）を読む。
 * 無ければ `null`（= 名簿未作成。従来経路のまま / 画面は空の名簿から始める）。
 * 書込は Callable `notificationRecipientsUpsert` のみ（Rules は write: false）。
 */
export async function fetchNotificationRecipients(
  tenantId: string,
  db: Firestore = defaultDb,
): Promise<NotificationRecipientsDoc | null> {
  const snap = await getDoc(doc(db, NOTIFICATION_RECIPIENTS_COLLECTION, tenantId));
  if (!snap.exists()) return null;
  return snap.data() as NotificationRecipientsDoc;
}
